/* eslint-disable @typescript-eslint/no-inferrable-types */
import { JournalDataEntryForm, PaginatedJournals } from "types/model.types";
import { authApi } from "./";

export const getDebitJournals = async (
  pageNumber: number = 1,
  pageSize: number = 30,
): Promise<void | PaginatedJournals> => {
  const { data } = await authApi.post<PaginatedJournals>("dbjournal/get", {
    pageNumber,
    pageSize,
  });
  return data;
};

export const submitJournal = async (
  payload: any,
): Promise<void | JournalDataEntryForm> => {
  const { data } = await authApi.post<JournalDataEntryForm>(
    "dbjournal/submit",
    payload,
  );
  return data;
};
export const deleteAdminDebitJnl = async (id: number): Promise<void | any> => {
  const { data } = await authApi.post<any>(`dbjournal/deleteAdminDbJournal`, {
    id,
  });
  return data;
};
export const getJournalById = (id: number): Promise<JournalDataEntryForm> => {
  return authApi
    .post<JournalDataEntryForm>("dbjournal/getJournalById", { id })
    .then((res) => res.data);
};
export const deleteJournalDetails = async (
  journalId: number,
  journalDetailIds: number[],
): Promise<void | any> => {
  const { data } = await authApi.post<any>("dbjournal/deleteDetails", {
    journalId,
    journalDetailIds,
  });
  return data;
};
